export const WORKER_STRINGS = {
    WORKER_NAME: "Worker Name",
    DELETE_WORKER: "Delete Worker",
    DISABLE_WORKER: "Disable Worker",
    SEARCH_WORKER: "Search Worker",
    CONFIRM_DISABLE: "Are you sure you want to disable",
    CONFIRM_DELETE: "Are you sure you want to delete",
};

export const WORKER_KEYS = {
    ID: "id",
    WORKER_NAME: "workername",
};

export const WORKER_TABLE_COLUMNS = [
    { id: "actions", isSortable: false, label: "Actions" },
    { id: "id", isSortable: true, label: "Worker ID" },
    { id: "state", isSortable: true, label: "State" },
    { id: "queue", isSortable: true, label: "Queue" },
    { id: "skill", isSortable: true, label: "Skill" },
    { id: "assignedJobId", isSortable: true, label: "Job" },
    { id: "assignedAtDate", isSortable: true, label: "Assign Time" },
];

export const WORKER_TABLE_COLUMN_KEYS = {
    ACTIONS: "actions",
    ID: "id",
    STATE: "state",
    QUEUE: "queue",
    SKILL: "skill",
    JOB: "job",
    TIME: "time",
};

export const WORKER_MESSAGES = {
    NO_WORKER: "No worker to display",
    WORKER_ADDED: "Worker added successfully!",
    WORKER_UPDATED: "Worker updated successfully!",
};

export const WORKER_ERRORS = {
    ADD_WORKER_ERROR: "Error adding worker:",
    SAVE_WORKER_ERROR: "Error saving worker:",
    UPDATE_WORKER_ERROR: "Error updating worker:",
    FETCH_WORKER_ERROR: "Error fetching worker:",
    DELETE_WORKER_ERROR: "Error deleting worker",
    REMOVE_WORKER_ERROR: "Error removing worker",
};

